import React from 'react';
import { Button } from '@material-ui/core';

export const TabAnalisis = () => {
  return (
    <React.Fragment>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '20vh', // Cambia la altura según tus necesidades
        }}
      >
        <Button
          style={{
            fontSize: '0.8rem',
            padding: 10,
          }}
          variant="contained"
          color="primary"
          onClick={() => {
            const url = 'https://microgen.servebbs.com/interpracsysweb/';
            window.open(url, '_blank');
          }}
        >
          Acceso a Microgen - Analisis Clinicos
        </Button>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '20vh', // Cambia la altura según tus necesidades
        }}
      >
        <Button
          style={{
            fontSize: '0.8rem',
            padding: 10,
          }}
          variant="contained"
          color="primary"
          onClick={() => {
            const url = 'http://200.69.255.3/viewer/index.php';
            window.open(url, '_blank');
          }}
        >
          Acceso a Visual Medica - Estudios / Imagenes
        </Button>
      </div>
    </React.Fragment>
  );
};
